import { FieldJson, FormJson } from 'edocatbase/Form';
import { assocPath, path } from 'ramda';
const moment = window.moment;

export const getValidConfig = (fields: { [key: string]: FieldJson }): { [key: string]: any } | null => {
    const dependencies = window?.__FORM_CONFIG__?.cbDepend;
    if (!dependencies) return null;
  
    let configFiltered: { [key: string]: any } = {};
    Object.keys(dependencies).forEach((itKey: string) => {
      let hasAll = true;
      let dependency = dependencies[itKey];
      hasAll &&= !!fields[itKey];
      if (dependency?.optionsUpdateBy) {
        dependency.optionsUpdateBy.forEach((src: any) => {
          hasAll &&= !!fields[src];
        });
      }else if(dependency?.valueUpdatedBy){
        dependency.valueUpdatedBy.forEach((src: any) => {
          hasAll &&= !!fields[src];
        });
      }else{
        hasAll = false;
      }
  
      if (hasAll) {
        configFiltered[itKey] = dependencies[itKey];
      }
    });
    return configFiltered;
  }
  
  export const customModFormJson = (formJson: FormJson, deps: any) => {
    Object.keys(deps).forEach(depKey => {
      let dep = deps[depKey];
      if (dep?.optionsUpdateBy) {
        dep.optionsUpdateBy.forEach((tgtKey: any) => {
          const currentValue: any = (formJson?.fields[tgtKey]?.value);
          const initialValue = typeof currentValue?.toJSON === 'function' ? currentValue.toJSON() :
            typeof currentValue === 'string' ?
              currentValue.length > 9 ? currentValue : "" : "";
          formJson = assocPath(["fields", depKey, "control", "params", "customQuery"], { fetchUrl: dep.url, srcKey: tgtKey, srcValue: initialValue }, formJson);
          formJson = assocPath(["fields", tgtKey, "control", "params", "customQueryUpdateOptionsTarget"], depKey, formJson);
        });
      }
  
      if (dep?.valueUpdatedBy) {
        dep.valueUpdatedBy.forEach((tgtKey: any) => {
          formJson = assocPath(["fields", tgtKey, "control", "params", "customQueryUpdateValue"],{ target: depKey, source: dep.valueFrom } , formJson);
        });
      }
  
    });
  
    return formJson;
  }
  